import React from "react";

import {
  TableContainerV2,
  TableHeaderV2,
} from "../../Client/Portfolio/shared/shared";
import { BorderedRow } from "@src/sharedComponents/List/BorderedList";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

import SubtleSpan from "./SubtleSpan";

interface Props {
  leftTitle: string;
  rightTitle: string;
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
}

const LoadingState: React.FC<Props> = (props) => {
  return (
    <TableContainerV2>
      <TableHeaderV2
        leftTitle={props.leftTitle}
        rightTitle={props.rightTitle}
      />
      <BorderedRow
        left={<SubtleSpan>{props.leftColumn}</SubtleSpan>}
        right={<SubtleSpan>{props.rightColumn}</SubtleSpan>}
      />
      <BorderedRow
        left={<Skeleton width={120} />}
        right={<Skeleton width={120} />}
      />
      <BorderedRow
        left={<Skeleton width={120} />}
        right={<Skeleton width={120} />}
      />
    </TableContainerV2>
  );
};

export default LoadingState;
